import { useEffect } from "react";

/**
 * Setzt Title, Description, Canonical und OG-Tags dynamisch für Persona-Landingpages.
 * Nach Unmount werden die Werte auf die Landing-Defaults zurückgesetzt.
 */
export function usePageMeta({ title, description, canonical, ogImage }) {
  useEffect(() => {
    const prev = {
      title: document.title,
      description: document.querySelector('meta[name="description"]')?.getAttribute("content"),
      canonical: document.querySelector('link[rel="canonical"]')?.getAttribute("href"),
      ogTitle: document.querySelector('meta[property="og:title"]')?.getAttribute("content"),
      ogDescription: document.querySelector('meta[property="og:description"]')?.getAttribute("content"),
      ogUrl: document.querySelector('meta[property="og:url"]')?.getAttribute("content"),
      ogImage: document.querySelector('meta[property="og:image"]')?.getAttribute("content"),
    };

    const setAttr = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el && value != null) el.setAttribute(attr, value);
    };

    if (title) document.title = title;
    setAttr('meta[name="description"]', "content", description);
    setAttr('link[rel="canonical"]', "href", canonical);
    setAttr('meta[property="og:title"]', "content", title);
    setAttr('meta[property="og:description"]', "content", description);
    setAttr('meta[property="og:url"]', "content", canonical);
    if (ogImage) setAttr('meta[property="og:image"]', "content", ogImage);
    setAttr('meta[name="twitter:title"]', "content", title);
    setAttr('meta[name="twitter:description"]', "content", description);
    if (ogImage) setAttr('meta[name="twitter:image"]', "content", ogImage);

    return () => {
      if (prev.title) document.title = prev.title;
      setAttr('meta[name="description"]', "content", prev.description);
      setAttr('link[rel="canonical"]', "href", prev.canonical);
      setAttr('meta[property="og:title"]', "content", prev.ogTitle);
      setAttr('meta[property="og:description"]', "content", prev.ogDescription);
      setAttr('meta[property="og:url"]', "content", prev.ogUrl);
      setAttr('meta[property="og:image"]', "content", prev.ogImage);
      setAttr('meta[name="twitter:title"]', "content", prev.ogTitle);
      setAttr('meta[name="twitter:description"]', "content", prev.ogDescription);
      setAttr('meta[name="twitter:image"]', "content", prev.ogImage);
    };
  }, [title, description, canonical, ogImage]);
}
